import React, { useState } from 'react';
import {
  IconButton,
  IconCertifiedSolid,
  IconCertifiedLine,
  Spinner,
  IamProtected,
} from '@smarterservices/smarter-ui';
import { getStore } from '../../../../stores/StoreContext';
import { ButtonWithConfirmation } from '@ui/shared/components/Common/ButtonWithConfirmation';
const ApproveAnnotationButton = ({
  annotation,
  onConfirm,
  onUnreview,
}) => {

  const [updatingStatus, setUpdatingStatus] = useState(false);
  const ExamSessionStore = getStore('examSessionStore');
  const AppStore = getStore('appStore');

  // calls to confirm this is a valid annotation...
  const handleConfirm = React.useCallback(async () => {
    setUpdatingStatus(true);
    const result = await ExamSessionStore.updateAnnotation(annotation.sid, {
      //TODO: Update the users name...
      reviewedBy: AppStore.user.username,
      reviewedDate: new Date().toISOString(),
      updatedBy: AppStore.user.username,
      updatedDate: new Date().toISOString(),
    });

    setUpdatingStatus(false);

    if (result.success) {
      onConfirm(result);
    }

  }, [ExamSessionStore, annotation.sid]);

  const handleUnreview = React.useCallback(async () => {
    setUpdatingStatus(true);
    const result = await ExamSessionStore.updateAnnotation(annotation.sid, {
      //TODO: Update the users name...
      reviewedBy: null,
      reviewedDate: null,
      updatedBy: AppStore.user.username,
      updatedDate: new Date().toISOString(),
    });

    setUpdatingStatus(false);

    if (result.success) {
      onUnreview(result);
    }
  }, [ExamSessionStore, annotation.sid]);

  return (
    <IamProtected
      action="sp:ModifyExamAnnotation"
      resource={AppStore.getIamResourceString(`annotation/${annotation.sid}`)}
    >
      {!annotation.reviewedDate ? (
        <IconButton
          size="small"
          margin="none x-small none none"
          screenReaderLabel="Edit Annotation"
          onClick={handleConfirm}
        >

          {updatingStatus ? <Spinner size="x-small" /> : <IconCertifiedLine />}
        </IconButton>
      ) : (
        // the annotation has been reviewed...
        <ButtonWithConfirmation
          onConfirm={handleUnreview}
          confirmationText="Unreview this item?"
          confirmButtonText="Yes"
          cancelButtonText="No"
          confirmButtonColor="danger"
          color={updatingStatus ? "secondary" : "success"}
          screenReaderLabel="Unreview Annotation"
        >
          {updatingStatus ? <Spinner size="x-small" /> : <IconCertifiedSolid />}
        </ButtonWithConfirmation>
      )}
    </IamProtected>
  );
};

export default ApproveAnnotationButton;
